import styled, { css } from "styled-components"

import Typography from "~/components/atoms/Typography"
import { Color, IsMobile, RadiusSize, Shadow, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  courseName: string
  arrowBottomMargin: string
}

interface StyledProps {
  arrowBottomMargin: string
}

const EmploymentFlow = ({ courseName, arrowBottomMargin }: Props) => {
  return (
    <StyledFlowStep>
      <StyledFlowStepArrowGroup arrowBottomMargin={arrowBottomMargin}>
        <StyledFlowStepArrow />
        <StyledFlowStepArrow />
      </StyledFlowStepArrowGroup>
      <StyledFlowStepItemBranchGroup>
        <StyledFlowStepItem>
          <Typography type="SubHeading">{courseName}</Typography>
        </StyledFlowStepItem>
      </StyledFlowStepItemBranchGroup>
      <StyledFlowStepItemBranchGroup>
        <StyledFlowStepItemBranch>
          <Typography type="MediumLabel">就職まで時間のある方</Typography>
        </StyledFlowStepItemBranch>
        <StyledFlowStepItemBranch>
          <Typography type="MediumLabel">就職まで時間のない方</Typography>
        </StyledFlowStepItemBranch>
      </StyledFlowStepItemBranchGroup>
      <StyledFlowStepItemBranchGroup>
        <StyledFlowStepItemHalf>
          <StyledFlowStepItemHalfTitle type="SubHeading">
            長期インターン
            {/* <span className="small">（10月〜）</span> */}
          </StyledFlowStepItemHalfTitle>
          <StyledFlowStepItemHalfCaption type="SubNote">
            実務経験がある学生は新卒採用時の本選考でとても高く評価されます。
          </StyledFlowStepItemHalfCaption>
        </StyledFlowStepItemHalf>
      </StyledFlowStepItemBranchGroup>
      <StyledFlowStepItemBranchGroup>
        <StyledFlowStepItem className="last-item">
          <Typography type="SubHeading">就職活動</Typography>
        </StyledFlowStepItem>
      </StyledFlowStepItemBranchGroup>
    </StyledFlowStep>
  )
}

const StyledFlowStep = styled.div`
  position: relative;
  top: 60px;
`
const StyledFlowStepArrowGroup = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  ${({ arrowBottomMargin }: StyledProps) => css`
    ${`
      margin-bottom: ${arrowBottomMargin}px;
    `}
  `}
`
const StyledFlowStepArrow = styled.div`
  position: relative;
  /* top: 90px; */
  margin-left: 25%;
  content: "";
  width: 1px;
  height: 212px;
  background: ${Color.LightGray};
  ${IsMobile(css`
    height: 260px;
    top: 44px;
  `)}
  &:before {
    display: inline-block;
    position: absolute;
    bottom: -4px;
    left: -6px;
    content: "";
    border-style: solid;
    border-width: 12px 7px 0 7px;
    border-color: ${Color.LightGray} transparent transparent transparent;
    ${IsMobile(css`
      bottom: -3px;
      left: -5px;
      border-width: 10px 6px 0 6px;
    `)}
  }
  &:last-of-type {
    margin-left: 0;
    margin-right: 25%;
  }
`

const StyledFlowStepItem = styled.div`
  width: 100%;
  background-color: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  ${Shadow.Deep};
  text-align: center;
  padding: 13px 0;
  &:nth-child(2) {
    margin-left: 24px;
    ${IsMobile(css`
      margin-left: 20px;
    `)}
  }
`
const StyledFlowStepItemHalf = styled.div`
  width: calc(50% - 12px);
  background-color: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  ${Shadow.Deep};
  text-align: center;
  padding: ${SpacingSize.L}px ${SpacingSize.M}px;
  ${IsMobile(css`
    width: calc(50% - 10px);
  `)}
`
const StyledFlowStepItemHalfTitle = styled(Typography)`
  color: ${Color.Primary};
  .small {
    font-size: ${TextSize.XS}px;
  }
`
const StyledFlowStepItemHalfCaption = styled(Typography)`
  margin-top: ${SpacingSize.XS}px;
`
const StyledFlowStepItemBranchGroup = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  margin: ${SpacingSize.XL}px 0;
  &.first-item {
    margin: 0;
  }
  &.course-type {
    margin-top: ${SpacingSize.M}px;
    ${IsMobile(css`
      margin-top: 12px;
    `)}
  }
  &.last-item {
    margin-bottom: 0;
  }
  ${IsMobile(css`
    margin: 20px 0;
  `)}
`
const StyledFlowStepItemBranch = styled.div`
  flex: 1;
  padding: ${SpacingSize.S}px;
  background-color: ${Color.Secondary};
  border-radius: ${RadiusSize.Medium}px;
  text-align: center;
  & > div {
    color: ${Color.White};
  }
  &:last-of-type {
    margin-left: ${SpacingSize.XL}px;
    background-color: ${Color.Attention};
    ${IsMobile(css`
      margin-left: 20px;
    `)}
  }
  ${IsMobile(css`
    padding: 11px 0;
    font-size: 10px;
  `)}
`

export default EmploymentFlow
